import React, { useContext, useState } from 'react';
import { message, Form, Input, Select, Button, InputNumber } from 'antd';
import { Context } from '../../../defaults';
import { saveInstitution } from '../../../actions';
import { integerRegex, schoolYearRegex } from '../../../common';
import './index.css';

export function InstitutionsAdd({
  languagesType,
  setAdded,
  setActive,
  paymentsTypes,
  institutionsType,
  subscriptionsType,
}) {
  const { dictionary, language, setLoading } = useContext(Context);
  const [form] = Form.useForm();
  const requiredMessage = dictionary?.FillTheField[language];
  const [paymentType, setPaymentType] = useState();
  const [year, setYear] = useState();
  const initialState = {
    name: '',
    description: '',
    langId: null,
    paymentTypeId: null,
    institutionTypeId: null,
    city: '',
    address: '',
  };

  const onSaveInstitution = () => {
    setLoading(true);
    form
      .validateFields()
      .then(() => {
        saveInstitution({
          ...form.getFieldsValue(),
        })
          .then(() => {
            setLoading(false);
            setAdded(true);
            setActive('2');
            message.success(dictionary?.SuccessfullyAdded[language], 4);
            form.resetFields();
          })
          .catch(({ response }) => {
            setLoading(false);
            console.log(response);
            !!response?.data?.errors?.Institutions
              ? message.error(response.data.errors.Institutions, 4)
              : message.error(dictionary?.SomethingWentWrong[language], 4);
          });
      })
      .catch(() => {
        setLoading(false);
        message.error(dictionary?.FormValidationFail[language], 4);
      });
  };

  const tailLayout = {
    wrapperCol: { offset: 8, span: 12 },
  };
  return (
    <Form
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 10 }}
      layout="horizontal"
      initialValues={initialState}>
      <Form.Item name="id" style={{ display: 'none' }}>
        <Input type={'hidden'} />
      </Form.Item>
      <Form.Item
        label={dictionary?.Name[language]}
        name="name"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] },
        ]}>
        <Input placeholder={dictionary?.Name[language]} />
      </Form.Item>
      <Form.Item
        label={dictionary?.Description[language]}
        name="description"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] },
        ]}>
        <Input placeholder={dictionary?.Description[language]} />
      </Form.Item>
      <Form.Item
        name="langId"
        label={dictionary?.Lang[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select placeholder={dictionary?.Lang[language]} allowClear={true}>
          {languagesType &&
            languagesType.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item
        name="paymentTypeId"
        label={dictionary?.PaymentType[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select
          placeholder={dictionary?.PaymentType[language]}
          allowClear={true}
          onChange={(id) => {
            setPaymentType(id);
          }}>
          {paymentsTypes &&
            paymentsTypes.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      {!!paymentType && paymentType === 1 && (
        <Form.Item
          name="subscriptionTypeId"
          label={dictionary?.SubscriptionType[language]}
          rules={[{ required: true, message: requiredMessage }]}>
          <Select placeholder={dictionary?.SubscriptionType[language]} allowClear={true}>
            {subscriptionsType &&
              subscriptionsType.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
      )}
      {!!paymentType && paymentType === 2 && (
        <Form.Item
          label={dictionary?.NumberOfStudents[language]}
          name="studentsCount"
          rules={[
            { required: true, message: requiredMessage },
            { pattern: integerRegex, message: dictionary?.OnlyNumber[language] },
          ]}>
          <Input placeholder={dictionary?.NumberOfStudents[language]} />
        </Form.Item>
      )}
      <Form.Item
        name="institutionTypeId"
        label={dictionary?.InstitutionType[language]}
        rules={[{ required: true, message: requiredMessage }]}>
        <Select placeholder={dictionary?.InstitutionType[language]} allowClear={true}>
          {institutionsType &&
            institutionsType.map((el) => {
              return (
                <Select.Option value={el.id} key={el.id}>
                  {el.name}
                </Select.Option>
              );
            })}
        </Select>
      </Form.Item>
      <Form.Item
        label={dictionary?.City[language]}
        name="city"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] },
        ]}>
        <Input placeholder={dictionary?.City[language]} />
      </Form.Item>
      <Form.Item
        label={dictionary?.Address[language]}
        name="address"
        rules={[
          { required: true, message: requiredMessage },
          { min: 1, message: dictionary?.MaxLengthField[language] },
          { max: 100, message: dictionary?.MaxLengthField[language] },
        ]}>
        <Input placeholder={dictionary?.Address[language]} />
      </Form.Item>
      <Form.Item
        name="studyYearFrom"
        label={dictionary?.StartYearOfStudy[language]}
        rules={[
          { required: true, message: requiredMessage },
          {
            pattern: schoolYearRegex,
            message: dictionary?.StudyYearRegexMessage[language],
          },
          {
            max: year,
            type: 'number',
            message: dictionary?.StudyYearStartRegexMessage[language],
          },
        ]}>
        <InputNumber
          style={{ width: 275, textAlign: 'center' }}
          placeholder={dictionary?.StartYearOfStudy[language]}
        />
      </Form.Item>
      <Form.Item
        name="studyYearTo"
        label={dictionary?.EndYearOfStudy[language]}
        rules={[
          { required: true, message: requiredMessage },
          {
            pattern: schoolYearRegex,
            message: dictionary?.StudyYearRegexMessage[language],
          },
        ]}
        shouldUpdate={true}>
        <InputNumber
          className="site-input-right"
          style={{
            width: 275,
            textAlign: 'center',
          }}
          onChange={setYear}
          value={year}
          placeholder={dictionary?.EndYearOfStudy[language]}
        />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type="primary" size="large" htmlType="submit" onClick={() => onSaveInstitution()}>
          {dictionary?.Add[language]}
        </Button>
      </Form.Item>
    </Form>
  );
}
